import BoardServiceClient from "../../Components/BoardServiceClient/BoardServiceClient";

function Dashboard() {
  return <BoardServiceClient />;
}

export default Dashboard;
